import { Component } from '@angular/core';
import { CellComponent } from '@spartacus/organization/administration/components';
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-user-cell',
    templateUrl: './uig-user-cell.component.html',
    styleUrls: ['./uig-user-cell.component.scss'],
    standalone: false
})
export class UigUserCellComponent extends CellComponent {

  constructor(protected outlet: OutletContextData<TableDataOutletContext>) {
    super(outlet);
  }
}
